/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class GuestCompounds extends Component {
  state = {
    data: {
      ArName: "",
      EnName: "",
      KuName: "",
      ArStatus: "",
      EnStatus: "",
      KuStatus: "",
      ArLocation: "",
      EnLocation: "",
      KuLocation: "",
      ArCategory: "",
      EnCategory: "",
      KuCategory: "",
      TotalTowers: "",
      TotalUnits: "",
      GrossSiteArea: "",
      Latitude: "",
      Longitude: "",
      LogoPath: null,
      PhotoPath: null,
    },

    contentHeader: "Compounds",
    addButtonLabel: "Add Compound",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetGuestCompounds",
    singleItemUrl: "/api/data/GetGuestCompound",
    addUrl: "/api/data/AddGuestCompound",
    editUrl: "/api/data/EditGuestCompound",
    deleteUrl: "/api/data/DeleteGuestCompound",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Compound",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Compound",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["ArName"] = apiResponse.data.respData.data[0].AR_NAME;
      data["EnName"] = apiResponse.data.respData.data[0].EN_NAME;
      data["KuName"] = apiResponse.data.respData.data[0].KU_NAME;
      data["ArStatus"] = apiResponse.data.respData.data[0].AR_STATUS;
      data["EnStatus"] = apiResponse.data.respData.data[0].EN_STATUS;
      data["KuStatus"] = apiResponse.data.respData.data[0].KU_STATUS;
      data["ArLocation"] = apiResponse.data.respData.data[0].AR_LOCATION;
      data["EnLocation"] = apiResponse.data.respData.data[0].EN_LOCATION;
      data["KuLocation"] = apiResponse.data.respData.data[0].KU_LOCATION;
      data["ArCategory"] = apiResponse.data.respData.data[0].AR_CATEGORY;
      data["EnCategory"] = apiResponse.data.respData.data[0].EN_CATEGORY;
      data["KuCategory"] = apiResponse.data.respData.data[0].KU_CATEGORY;
      data["TotalTowers"] = apiResponse.data.respData.data[0].TOTAL_TOWERS;
      data["TotalUnits"] = apiResponse.data.respData.data[0].TOTAL_UNITS;
      data["GrossSiteArea"] = apiResponse.data.respData.data[0].GROSS_SITE_AREA;
      data["Latitude"] = apiResponse.data.respData.data[0].LATITUDE;
      data["Longitude"] = apiResponse.data.respData.data[0].LONGITUDE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);
    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    const data = new FormData();
    if (this.state.data.file) {
      data.append(
        "LogoPath",
        this.state.data.LogoPath,
        this.state.data.LogoPath.name
      );
    }

    if (this.state.data.file) {
      data.append(
        "PhotoPath",
        this.state.data.PhotoPath,
        this.state.data.PhotoPath.name
      );
    }

    data.append("requestData", JSON.stringify(submitData));
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.arabicName"),
        field: "AR_NAME",
      },
      {
        id: 2,
        label: t("col.englishName"),
        field: "EN_NAME",
      },
      {
        id: 3,
        label: t("col.kurdishName"),
        field: "KU_NAME",
      },
      {
        id: 4,
        label: t("col.arabicStatus"),
        field: "AR_STATUS",
      },
      {
        id: 5,
        label: t("col.englishStatus"),
        field: "EN_STATUS",
      },
      {
        id: 6,
        label: t("col.kurdishStatus"),
        field: "KU_STATUS",
      },
      {
        id: 7,
        label: t("col.kurdishLocation"),
        field: "AR_LOCATION",
      },
      {
        id: 8,
        label: t("col.kurdishLocation"),
        field: "EN_LOCATION",
      },
      {
        id: 9,
        label: t("col.kurdishLocation"),
        field: "KU_LOCATION",
      },
      {
        id: 10,
        label: t("col.kurdishCategory"),
        field: "AR_CATEGORY",
      },
      {
        id: 11,
        label: t("col.kurdishCategory"),
        field: "EN_CATEGORY",
      },
      {
        id: 12,
        label: t("col.kurdishCategory"),
        field: "KU_CATEGORY",
      },
      {
        id: 13,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 14,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 15,
        field: "LOGO_PATH",
        label: t("col.logo"),
        cellRenderer: ({ data }) => {
          return (
            <a href={data.LOGO_PATH} target="blank" style={{ color: "black" }}>
              View File
            </a>
          );
        },
      },
      {
        id: 16,
        field: "PHOTO_PATH",
        label: t("col.photo"),
        cellRenderer: ({ data }) => {
          return (
            <a href={data.PHOTO_PATH} target="blank" style={{ color: "black" }}>
              View File
            </a>
          );
        },
      },
      {
        id: 17,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB56"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB57"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.guestServices")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB54"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "ArName",
                label: t("col.arabicName"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnName",
                label: t("col.englishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuName",
                label: t("col.kurdishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArStatus",
                label: t("col.arabicStatus"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnStatus",
                label: t("col.englishStatus"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuStatus",
                label: t("col.kurdishStatus"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArLocation",
                label: t("col.arabicLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnLocation",
                label: t("col.englishLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuLocation",
                label: t("col.kurdishLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArCategory",
                label: t("col.arabicCategory"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnCategory",
                label: t("col.englishCategory"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuCategory",
                label: t("col.kurdishCategory"),
                disabled: false,
              },
              {
                type: "text",
                id: "TotalTowers",
                label: t("col.totalTowers"),
                disabled: false,
              },
              {
                type: "text",
                id: "TotalUnits",
                label: t("col.totalUnits"),
                disabled: false,
              },
              {
                type: "text",
                id: "GrossSiteArea",
                label: t("col.grossArea"),
                disabled: false,
              },
              {
                type: "text",
                id: "Latitude",
                label: t("col.latitude"),
                disabled: false,
              },
              {
                type: "text",
                id: "Longitude",
                label: t("col.longitude"),
                disabled: false,
              },
              {
                type: "fileupload",
                id: "LogoPath",
                label: t("col.logoPath"),
                disabled: false,
              },
              {
                type: "fileupload",
                id: "PhotoPath",
                label: t("col.photoPath"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(GuestCompounds);
